import { cn } from "../../app/components/primitives/utils";

// The attention trail (Ben, 5 Oct): wherever the customer must act, the same
// warning dot shows at every level (tab, item row, sub-tab) and the exact
// thing to act on gets the same subtle warning tint. One token everywhere:
// the theme's `warning`. Never colour alone: the dot carries a label.

/** The subtle tint on the one component that needs the customer. */
export const ATTENTION_TINT = "border border-warning/50 bg-warning/5";

export function AttentionDot({
  label = "Needs you",
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={cn(
        "inline-block size-2 shrink-0 rounded-full bg-warning",
        className,
      )}
    />
  );
}
